import { useSelectedItems } from "@/context/SelectedItemsContext";
import { useEffect, useState } from "react";

// Enum pour les types de contenu
export const ContentType = Object.freeze({
    EXPENSE: "EXPENSE",
    PAYSLIP: "PAYSLIP",
    COMPANY_BENEFIT: "COMPANY_BENEFIT",
    TIMESHEET: "TIMESHEET",
    INVOICE: "INVOICE",
    OTHER: "OTHER"
});

export default function MultiSelectorComponent({ children, item, idOfContent, typeOfContent, idConsultant }) {
    const { selectedItems, setSelectedItems } = useSelectedItems();
    const [isSelected, setIsSelected] = useState(false);

    useEffect(() => {
        // Vérifie si l'élément est déjà sélectionné dans le contexte
        const isCurrentlySelected = selectedItems.some((i) => i.uuid === idOfContent);
        setIsSelected(isCurrentlySelected);
    }, [selectedItems, idOfContent]);

    const handleSelection = () => {
        if (isSelected) {
            // Désélectionner l'élément
            setSelectedItems((prev) => prev.filter((i) => i.uuid !== idOfContent));
        } else {
            // Sélectionner l'élément
            setSelectedItems((prev) => [...prev, { ...item, uuid: idOfContent, type: typeOfContent, idConsultant }]);
        }
    };

    const handleClick = (event) => {
        if (event.ctrlKey || event.metaKey) { // `metaKey` pour Command sur Mac
            handleSelection();
        }
    };

    return (
        <div
            onClick={handleClick}
            className={`w-full rounded-sm ${isSelected ? "border border-2 border-information" : ""}`}
        >
            {children}
        </div>
    );
}